<template>
  <div class="LC_productivity" ref="LC_productivity">
    <div class="lookMore" @click="openCEPage">
      {{isVisit ? '' : 'C+4E ☰'}}
    </div>
    <div class="productivity-box">
      <div class="chart" ref="chart"></div>
    </div>
  </div>
</template>



<script>
import getOpt from "./chartBar.js";
import { unwarp } from "@/utils/tools.js";
import { mapGetters } from "vuex";
import cEPage from "./components/cEpage.vue";

export default {
  props: ["matrix", "x", "y"],
  components: { cEPage },
  data() {
    return {
      pageInfo: 'LC_productivity.vue',
      computedName: '碳生产率组件',
      customerId: this.$store.state.customerId,
      chart: null,
    };
  },
  computed: {
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
    isVisit() {
      return this.$store.state.isVisit
    },
  },

  watch: {},

  created() {},

  mounted() {
    let that = this;
    let w = $(that.$refs.LC_productivity).outerWidth();
    let h = $(that.$refs.LC_productivity).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.renderChart();
  },

  methods: {
    async renderChart() {
      if (!this.chart) {
        this.chart = echarts.init(this.$refs.chart);
      }
      const findCarbonProductivity =
        CONFIG.requestName + this.$apiOpt.findCarbonProductivity;
      let res = await this.$apiUtils.get(findCarbonProductivity, {
        customerId: this.customerId,
      });
      const monthArr = new Array(12).fill(0);
      res && res.length && res.forEach((item) => {
        let month = item.month && item.month.split("-");
        if (month && month.length) item.id = month[1] && Number(month[1]);
        monthArr[item.id - 1] = item.total && Number(item.total).toFixed(2);
      });
      unwarp(this.chart).setOption(getOpt(monthArr));
    },
    openCEPage() {
      if (this.isVisit) {
        return
      }
      this.$store.commit("dialogStatus", true);
      this.$popup.open(cEPage, this.dialogCompontent);
    },
  },
};
</script>



<style lang="scss" scoped="scoped">
.LC_productivity {
  height: 250px;
  width: 600px;
  padding-top: 52px !important;
  .lookMore {
    position: absolute;
    top: 20px;
    right: 23px;
    font-size: 18px;
    color: #4be0ff;
    cursor: pointer;
  }
  .productivity-box {
    width: 100%;
    height: 178px;
    background: linear-gradient(
      180deg,
      rgba(108, 151, 255, 0.2) 0%,
      rgba(107, 151, 255, 0.2) 48%,
      rgba(58, 116, 255, 0.1) 100%
    );
    border: 1px solid rgba(38, 76, 169, 0.53);
    // filter: blur(2px);
    .chart {
      width: 100%;
      height: 100%;
      // margin-top: 20px;
    }
  }
}
</style>
